import { Modal } from "antd";
import { useSelector } from "react-redux";

const EmbryologyDataSheetModal = ({ isOpen, onClose }) => {
  const theme = localStorage.getItem("default-theme");

  const { activePatientJourneyModuleDetails } = useSelector(
    ({ dashboard }) => dashboard
  );

  return (
    <>
      <Modal
        centered
        open={isOpen}
        title="Embryology Data Sheet Detail"
        className={`patient-registration-modal theme-${theme}`}
        maskClosable={false}
        onCancel={() => onClose()}
        width={860}
      >
        <div className="modal-details">
          <div className="modal-content-details">
            <div className="details">
              <div className="details-table">
                <div>Patient ID</div>
                <div>{activePatientJourneyModuleDetails?.patient_id}</div>
                <div>Patient</div>
                <div>
                  {activePatientJourneyModuleDetails?.patient_full_name}
                </div>
                <div>Patient Age</div>
                <div>{activePatientJourneyModuleDetails?.patient_dob}</div>
                <div>Partner</div>
                <div>
                  {activePatientJourneyModuleDetails?.partner_full_name}
                </div>
                <div>Partner Age</div>
                <div>{activePatientJourneyModuleDetails?.partner_dob}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">
                Patient Registration & Basic info from patient
              </div>
              <div className="details-table">
                <div>Male Partner</div>
                <div>{activePatientJourneyModuleDetails?.male_partner}</div>
                <div>Age (Male)</div>
                <div>{activePatientJourneyModuleDetails?.age_male}</div>
                <div>Female Partner</div>
                <div>{activePatientJourneyModuleDetails?.female_partner}</div>
                <div>Age (Female)</div>
                <div>{activePatientJourneyModuleDetails?.age_female}</div>
                <div>Pt. ID</div>
                <div>{activePatientJourneyModuleDetails?.pt_id}</div>
                <div>Collection</div>
                <div>{activePatientJourneyModuleDetails?.collections}</div>
                <div>Collections Other</div>
                <div>
                  {activePatientJourneyModuleDetails?.collections_other}
                </div>
                <div>Complete Collection</div>
                <div>
                  {activePatientJourneyModuleDetails?.complete_collection}
                </div>
                <div>Rec.No.</div>
                <div>{activePatientJourneyModuleDetails?.rec_no}</div>
                <div>Date</div>
                <div>{activePatientJourneyModuleDetails?.date}</div>
                <div>Referring clinic/clinician</div>
                <div>{activePatientJourneyModuleDetails?.refer_clinic}</div>
                <div>Method Of Collection</div>
                <div>
                  {activePatientJourneyModuleDetails?.method_collection}
                </div>
                <div>Abstinence Period (Days)</div>
                <div>
                  {activePatientJourneyModuleDetails?.abstinance_period}
                </div>
                <div>Collection time(CT)</div>
                <div>{activePatientJourneyModuleDetails?.collection_time}</div>
                <div>Assay time (AT)</div>
                <div>{activePatientJourneyModuleDetails?.assay_time}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">
                Ejaculate – Macroscopic examination
              </div>
              <div className="details-table">
                <div>Ejaculate volume</div>
                <div>{activePatientJourneyModuleDetails?.ejaculate_volume}</div>
                <div>Liquification Time</div>
                <div>
                  {activePatientJourneyModuleDetails?.liquification_time}
                </div>
                <div>PH</div>
                <div>{activePatientJourneyModuleDetails?.ph}</div>
                <div>Visual appearance</div>
                <div>
                  {activePatientJourneyModuleDetails?.visual_appeareance}
                </div>
                <div>Viscosity</div>
                <div>{activePatientJourneyModuleDetails?.viscosity}</div>
                <div>Treatment</div>
                <div>{activePatientJourneyModuleDetails?.treatment}</div>
                <div>Fructose</div>
                <div>{activePatientJourneyModuleDetails?.fructose}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">
                Ejaculate – Macroscopic examination
              </div>
              <div className="details-table">
                <div>HOS test</div>
                <div>{activePatientJourneyModuleDetails?.hos_test}</div>
                <div>Vitality</div>
                <div>{activePatientJourneyModuleDetails?.vitality}</div>
                <div>Teratozoospermia index</div>
                <div>
                  {activePatientJourneyModuleDetails?.teratozoospermia_index}
                </div>
                <div>Agglutination</div>
                <div>{activePatientJourneyModuleDetails?.agglutination}</div>
                <div>Aggregations</div>
                <div>{activePatientJourneyModuleDetails?.aggregations}</div>
                <div>Interpretation</div>
                <div>{activePatientJourneyModuleDetails?.interpretations}</div>
                <div>Decision Limits</div>
                <div>{activePatientJourneyModuleDetails?.decision_limits}</div>
                <div>Notes</div>
                <div>{activePatientJourneyModuleDetails?.notes}</div>
                <div>Examination done by</div>
                <div>
                  {activePatientJourneyModuleDetails?.examination_done_by}
                </div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Count</div>
              <div className="details-table">
                <div>Concentration</div>
                <div>
                  {activePatientJourneyModuleDetails?.concentration}Million/ml
                </div>
                <div>Concentration (if less than Million/ml)</div>
                <div>{activePatientJourneyModuleDetails?.concentration_ml}</div>
                <div>Total Motile Count</div>
                <div>
                  {activePatientJourneyModuleDetails?.total_motile_count}
                  Million/ejaculate
                </div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Other then sperm cells</div>
              <div className="details-table">
                <div>Pus cells/Leucocytes</div>
                <div>
                  {activePatientJourneyModuleDetails?.pus_cells_leucocytes}/hpf
                </div>
                <div>Debries</div>
                <div>{activePatientJourneyModuleDetails?.debries}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Motility</div>
              <div className="details-table">
                <div>Total motile (a+b+c)</div>
                <div>{activePatientJourneyModuleDetails?.total_motile}</div>
                <div>All progressive (a+b)</div>
                <div>{activePatientJourneyModuleDetails?.all_progressive}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Motility progression</div>
              <div className="details-table">
                <div>a) Rapid progressive</div>
                <div>
                  {activePatientJourneyModuleDetails?.rapid_progressive}
                </div>
                <div>b) Slow progressive</div>
                <div>{activePatientJourneyModuleDetails?.slow_progressive}</div>
                <div>c) Non-progressive</div>
                <div>{activePatientJourneyModuleDetails?.non_progressive}</div>
                <div>d) Immotile</div>
                <div>{activePatientJourneyModuleDetails?.immotile}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Morphology</div>
              <div className="details-table">
                <div>Normal forms</div>
                <div>{activePatientJourneyModuleDetails?.normal_forms}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Abnormality</div>
              <div className="details-table">
                <div>Abnormal heads</div>
                <div>{activePatientJourneyModuleDetails?.abnormal_heads}</div>
                <div>Abnormal midpieces</div>
                <div>
                  {activePatientJourneyModuleDetails?.abnormal_midpieces}
                </div>
                <div>Abnormal tails</div>
                <div>{activePatientJourneyModuleDetails?.abnormal_tails}</div>
                <div>Excess residual cytoplasm</div>
                <div>
                  {activePatientJourneyModuleDetails?.excess_residual_cytoplasm}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EmbryologyDataSheetModal;
